export default [
  {
    value: 'round_shape',
    label: 'Round'
  },
  {
    value: 'princess',
    label: 'Princess'
  },
  {
    value: 'step_cut_trapezoid',
    label: 'Step Cut Trapezoid'
  },
  {
    value: 'faceted_trapezoid',
    label: 'Faceted Trapezoid'
  },
  {
    value: 'half_moon',
    label: 'Half Moon'
  },
  {
    value: 'tapered_baguette',
    label: 'Tapered Baguette'
  },
  {
    value: 'straight_baguette',
    label: 'Straight Baguette'
  },
  {
    value: 'pear',
    label: 'Pear'
  },
  {
    value: 'oval',
    label: 'Oval'
  },
  {
    value: 'triangle',
    label: 'Triangle'
  },
  {
    value: 'cushion',
    label: 'Cushion'
  },
  {
    value: 'radiant',
    label: 'Radiant'
  },
  {
    value: 'emerald',
    label: 'Emerald'
  },
  {
    value: 'asscher',
    label: 'Asscher'
  },
  {
    value: 'marquise',
    label: 'Marquise'
  }
]



// WEBPACK FOOTER //
// ./src/components/select-shapes/multi_stone_shapes.js